/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
class CartItems extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('.cart-items__form');
    this.emptyMessage = this.querySelector('.cart-items__empty');
    this.lineItemStatusElement = document.getElementById(
      'shopping-cart-line-item-status'
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = theme.debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.sectionId,
        selector: '.cart-items__products',
      },
      {
        id: 'cart-button',
        section: 'cart-button',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.sectionId,
        selector: '.cart-block__subtotal',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${theme.routes.cart_change_url}`, {
      ...theme.fetchConfig(),
      ...{body},
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        // Hide cart footer elements too
        if (parsedState.item_count === 0) {
          this.form.classList.add('hidden');
          this.emptyMessage.classList.remove('hidden');
        } else {
          this.form.classList.remove('hidden');
          this.emptyMessage.classList.add('hidden');
        }

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      })
      .catch((error) => {
        this.querySelectorAll(`.loading-spinner`).forEach(
          (spinner) => {
            spinner.classList.remove('hidden')
            spinner.classList.add('block')
          }
        );
        document.getElementById('cart-errors').textContent =
          window.cartStrings.error;
        this.disableLoading();
      });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount) {
    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  enableLoading(line) {
    this.form.classList.add('pointer-events-none');
    this.querySelectorAll(`#CartItem-${line} .loading-spinner`).forEach(
      (spinner) => {
        const totalContent = spinner.parentElement.querySelector('.cart-item__total-content');
        totalContent.classList.add('hidden');
        spinner.classList.remove('hidden')
        spinner.classList.add('block')
      }
    );
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    this.form.classList.remove('pointer-events-none');
  }
}
customElements.define('cart-items', CartItems);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartAgreement extends HTMLElement {
  constructor() {
    super();
    
    this.section = this.closest('[data-section-id]');
    this.checkoutButtons = this.section.querySelector('.cart-block__buttons');
    if (!this.checkoutButtons) return;

    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.toggleCheckout(this.checkbox.checked);

    this.checkbox.addEventListener('change', (event) => {
      this.toggleCheckout(event.currentTarget.checked);
    });
  }

  toggleCheckout(checked) {
    if (checked === true) {
      this.checkoutButtons.classList.remove('pointer-events-none', 'opacity-50');
    } else {
      this.checkoutButtons.classList.add('pointer-events-none', 'opacity-50');
    }
  }
}
customElements.define('cart-agreement', CartAgreement);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', theme.debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${theme.routes.cart_update_url}`, {...theme.fetchConfig(), ...{ body }});
    }, 300))
  }  
}
customElements.define('cart-note', CartNote);



/******/ })()
;